import queryString from 'query-string';
import { isUndefined, pickBy } from 'lodash';

export default (params) => queryString.stringify(pickBy({ ...params }, (item) => !isUndefined(item)));
